import React from 'react';
import { Row } from 'reactstrap';

import {  useFlightReviews } from '../Common';

export default function PassengerReview() {
  const { passengerDetails } = useFlightReviews()

  return passengerDetails.map(
    ({ firstName, lastName, paxType, nationality, gender }, idx) => {
      const values = [
        { title: 'Name', value: `${firstName} ${lastName}` },
        { title: 'Passenger', value: paxType },
        { title: 'Nationality', value: nationality },
        { title: 'Gender', value: gender },
      ];

      return (
        <div className="pass-list" key={idx}>
          <h4>PASSENGER {Number(idx) + 1}</h4>
          <Row>
            <div className="col-12 box-holder">
              {values.map(({ title, value }) => (
                <div className="box-wrap" key={title}>
                  <h5>{title}</h5>
                  <p>{value}</p>
                </div>
              ))}
            </div>
          </Row>
        </div>
      );
    }
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/PassengerReview.js